import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ColorSchemes } from 'src/styles/color-scheme.type';
import { LocLabel } from '../clickable-row-table/models/data-table-config.models';

export interface ConfirmationData {
  /** @deprecated use textKey */
  text?: string;
  textKey?: string | LocLabel;
  acceptKey: string;
  cancelKey?: string;
  colors?: ColorSchemes;
}

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data: ConfirmationData) {}

  ColorSchemes = ColorSchemes;
  ngOnInit(): void {}
}
